import { defineMessages } from '@formatjs/intl';

import {
  vehicleSpecBodyTypeDefinition,
  vehicleSpecFuelTypeDefinition,
  vehicleSpecGearBoxDefinition,
} from '../Vehicle/Vehicle.messages';
import { quickLinkMessages } from './QuickLinks.messages';
import { savedSearchMessages } from './SavedSearch.messages';
export const scope = 'containers.component.PLP';

export const filterOverviewMessages = {
  overviewMore: {
    id: `${scope}.overviewMore`,
    defaultMessage: 'more',
  },
  overviewLess: {
    id: `${scope}.overviewLess`,
    defaultMessage: 'View less',
  },
  overviewRemove: {
    id: `${scope}.overviewRemove`,
    defaultMessage: 'Remove filter',
  },
  filtersDistanceUnit: {
    id: `${scope}.filtersDistanceUnit`,
    defaultMessage: 'miles',
  },
  filtersDoorsUnit: {
    id: `${scope}.filtersDoorsUnit`,
    defaultMessage: 'doors',
  },
  filtersEmissionUnit: {
    id: `${scope}.filtersEmissionUnit`,
    defaultMessage: 'Category',
  },
  filtersEngineSizeUnit: {
    id: `${scope}.filtersEngineSizeUnit`,
    defaultMessage: 'L',
  },
  filtersSeatsUnit: {
    id: `${scope}.filtersSeatsUnit`,
    defaultMessage: 'seats',
  },
  filtersEvRangeUnit: {
    id: `${scope}.filtersEvRangeUnit`,
    defaultMessage: 'km',
  },
  filtersEvRangeMinLabel: {
    id: `${scope}.evRange.minLabel`,
    defaultMessage: 'autonomie', //range
  },
  filtersAny: {
    id: `${scope}.filtersAny`,
    defaultMessage: 'any',
  },
  'price-reduced': {
    id: `${scope}.priceReduced`,
    defaultMessage: 'Price reduced',
  },
  maxPrice: {
    id: `${scope}.maxPrice`,
    defaultMessage: 'any',
  },
  minPrice: {
    id: `${scope}.minPrice`,
    defaultMessage: 'any',
  },
  maxMileage: {
    id: `${scope}.maxMileage`,
    defaultMessage: 'any',
  },
  minMileage: {
    id: `${scope}.minMileage`,
    defaultMessage: 'any',
  },
  maxPower: {
    id: `${scope}.maxPower`,
    defaultMessage: 'any',
  },
  minPower: {
    id: `${scope}.minPower`,
    defaultMessage: 'any',
  },
  maxBhp: {
    id: `${scope}.maxBhp`,
    defaultMessage: 'any',
  },
  minBhp: {
    id: `${scope}.minBhp`,
    defaultMessage: 'any',
  },
  within: {
    id: `${scope}.within`,
    defaultMessage: 'Within',
  },
};

export const genericControlsMessages = {
  max: {
    id: `${scope}.max`,
    defaultMessage: 'Max',
  },
  min: {
    id: `${scope}.min`,
    defaultMessage: 'Min',
  },
  reset: {
    id: `${scope}.reset`,
    defaultMessage: 'Reset',
  },
};

export const accordionHeadingsMessages = {
  location: {
    id: `${scope}.accordionHeading.location`,
    defaultMessage: 'Location',
  },
  price: {
    id: `${scope}.accordionHeading.price`,
    defaultMessage: 'Price',
  },
  make: {
    id: `${scope}.accordionHeading.make`,
    defaultMessage: 'Make',
  },
  model: {
    id: `${scope}.accordionHeading.model`,
    defaultMessage: 'Model',
  },
  'variant-type': {
    id: `${scope}.accordionHeading.modelVariant`,
    defaultMessage: 'Model variant',
  },
  showOnly: {
    id: `${scope}.accordionHeading.showOnly`,
    defaultMessage: 'Show only',
  },
  offers: {
    id: `${scope}.accordionHeading.offers`,
    defaultMessage: 'Offers & Services',
  },
  year: {
    id: `${scope}.accordionHeading.year`,
    defaultMessage: 'Year',
  },
  mileage: {
    id: `${scope}.accordionHeading.mileage`,
    defaultMessage: 'Mileage',
  },
  fuelType: {
    id: `${scope}.accordionHeading.fuelType`,
    defaultMessage: 'Fuel type',
  },
  gearBox: {
    id: `${scope}.accordionHeading.gearBox`,
    defaultMessage: 'Gear box',
  },
  color: {
    id: `${scope}.accordionHeading.color`,
    defaultMessage: 'Colour',
  },
  enginePower: {
    id: `${scope}.accordionHeading.enginePower`,
    defaultMessage: 'Power',
  },
  evWltpRange: {
    id: `${scope}.accordionHeading.evWltpRange`,
    defaultMessage: 'Autonomie VE',
  },
  doors: {
    id: `${scope}.accordionHeading.doors`,
    defaultMessage: 'Doors',
  },
  seats: {
    id: `${scope}.accordionHeading.seats`,
    defaultMessage: 'Seats',
  },
  bodyType: {
    id: `${scope}.accordionHeading.bodyType`,
    defaultMessage: 'Body type',
  },
  emissionSticker: {
    id: `${scope}.accordionHeading.emissionSticker`,
    defaultMessage: 'Environment certificate',
  },
  engineSize: {
    id: `${scope}.accordionHeading.engineSize`,
    defaultMessage: 'Engine Size',
  },
  includeSold: {
    id: `${scope}.accordionHeading.includeSold`,
    defaultMessage: 'Sold vehicle',
  },
  hideSold: {
    id: `${scope}.accordionHeading.hideSold`,
    defaultMessage: 'Hide sold vehicles',
  },
  'fuel-consumption': {
    id: `${scope}.accordionHeading.consumption`,
    defaultMessage: 'Consumption',
  },
  newCarEu24: {
    id: `${scope}.accordionHeading.newCarEu24`,
    defaultMessage: 'Neuwagen Angebote',
  },
};

export const priceMessages = {
  discountOnly: {
    id: `${scope}.price.discountOnly`,
    defaultMessage: 'Only show discounted cars',
  },
  'total-price': {
    id: `${scope}.price.total`,
    defaultMessage: 'Total price',
  },
  'monthly-price': {
    id: `${scope}.price.monthly`,
    defaultMessage: 'Monthly',
  },
  financeType: {
    id: `${scope}.price.financeType`,
    defaultMessage: 'Finance type',
  },
  onlyOnHeyCar: {
    id: `${scope}.price.onlyOnHeyCar`,
    defaultMessage: 'Only on heycar',
  },
};

export const fuelMessages = {
  diesel: {
    id: `${scope}.fuel.diesel`,
    defaultMessage: 'Diesel',
  },
  other: {
    id: `${scope}.fuel.other`,
    defaultMessage: 'Other',
  },
  hybrid: {
    id: `${scope}.fuel.hybrid`,
    defaultMessage: 'Hybrid',
  },
  petrol: {
    id: `${scope}.fuel.petrol`,
    defaultMessage: 'Petrol',
  },
  electric: {
    id: `${scope}.fuel.electric`,
    defaultMessage: 'Electric',
  },
  gas: {
    id: `${scope}.fuel.gas`,
    defaultMessage: 'Gas',
  },
};

export const yearMessages = {
  yearInfoLine: {
    id: `${scope}.year.infoLine`,
    defaultMessage: 'All out cars are less than 8 years old',
  },
  'stock-condition-both': {
    id: `${scope}.year.stock-condition-both`,
    defaultMessage: 'All',
  },
  'stock-condition-used': {
    id: `${scope}.year.stock-condition-used`,
    defaultMessage: 'Used',
  },
  'stock-condition-new': {
    id: `${scope}.year.stock-condition-new`,
    defaultMessage: 'New',
  },
};

export const promotionFilterMessages = {
  'has-offers-or-promotions': {
    id: `${scope}.promotionsFilterLabel`,
    defaultMessage: 'Promotions',
  },
};

export const mileageMessages = {
  mileageInfoLine: {
    id: `${scope}.mileage.infoLine`,
    defaultMessage: 'At heycar, all our cars have less than 100,000 miles on the clock',
  },
};

export const evRangeMessages = {
  evRangeInfoLine: {
    id: `${scope}.evRange.infoLine`,
    defaultMessage: 'Filtrer les véhicules électriques par leur autonomie WLTP',
  },
  evRangeMinLabel: {
    id: `${scope}.evRange.minLabel`,
    defaultMessage: 'Min range',
  },
};

export const enginePowerMessages = {
  bhp: {
    id: `${scope}.enginePower.bhp`,
    defaultMessage: 'bhp',
  },
  kw: {
    id: `${scope}.enginePower.kw`,
    defaultMessage: 'kW',
  },
};

export const makeMessages = {
  searchPlaceholder: {
    id: `${scope}.make.searchPlaceholder`,
    defaultMessage: 'Search',
  },
  popularMakes: {
    id: `${scope}.make.popularMakes`,
    defaultMessage: 'Popular Makes',
  },
  allAvailableMakes: {
    id: `${scope}.make.allAvailableMakes`,
    defaultMessage: 'All available makes',
  },
};

export const locationMessages = {
  postcode: {
    id: `${scope}.location.postcode`,
    defaultMessage: 'Postcode',
  },
  region: {
    id: `${scope}.location.region`,
    defaultMessage: 'Region',
  },
  errorMessage: {
    id: `${scope}.location.errorMessage`,
    defaultMessage: 'Sorry, there has been an error.',
  },
  ukErrorMessage: {
    id: `${scope}.location.ukErrorMessage`,
    defaultMessage: 'Please enter a valid UK postcode',
  },
};
export const showOnlyMessages = {
  ecom: {
    id: `${scope}.showOnly.ecom`,
    defaultMessage: 'Buy online',
  },
  ecomDesc: {
    id: `${scope}.showOnly.ecomDesc`,
    defaultMessage: 'Cars you can buy online without leaving your home',
  },
  d2c: {
    id: `${scope}.showOnly.d2c`,
    defaultMessage: 'Only on heycar',
  },
  d2cDesc: {
    id: `${scope}.showOnly.d2cDesc`,
    defaultMessage: 'Cars you can buy exclusively from heycar',
  },
  d2cDesc2: {
    id: `${scope}.buyOnline.d2cDesc2`,
    defaultMessage: 'Cars eligible for £700 cashback ',
  },
  d2cLabel2: {
    id: `${scope}.buyOnline.d2cLabel2`,
    defaultMessage: '£700 Cashback offer',
  },
  d2cRac: {
    id: `${scope}.showOnly.d2cRac`,
    defaultMessage: 'Exclusive cars',
  },
  d2cRacDesc: {
    id: `${scope}.showOnly.d2cRacDesc`,
    defaultMessage: 'Cars you can buy exclusively from our partners',
  },
  rac: {
    id: `${scope}.showOnly.rac`,
    defaultMessage: 'RAC approved dealers',
  },
  racDesc: {
    id: `${scope}.showOnly.racDesc`,
    defaultMessage: 'Only our trusted dealers',
  },
  heyConExclusive: {
    id: `${scope}.showOnly.heyConExclusive`,
    defaultMessage: 'Heycar exclusivité',
  },
};

export const newCarEu24Messages = {
  newCarEu24: {
    id: `${scope}.newCarEu24`,
    defaultMessage: 'Neuwagen',
  },
  newCarEu24Desc: {
    id: `${scope}.newCarEu24Desc`,
    defaultMessage:
      'Fahrzeuge ohne Erstzulassung oder mit sehr geringer Laufleistung – maximal 8 Monate alt oder höchstens 1.000 km gefahren. Ideal für alle, die ein nahezu neues Auto kaufen möchten – mit aktuellem Technikstand und meist sofort verfügbar',
  },
};

export const includeSoldMessages = {
  includeSoldInfoLine: {
    id: `${scope}.includeSold.infoLine`,
    defaultMessage: 'Include sold cars in search results',
  },
};

export const errorMessages = {
  noResults: {
    id: `${scope}.search.noResults`,
    defaultMessage: 'Sorry, no results. Try tweaking your search',
  },
};

export const colorMessages = {
  beige: {
    id: `${scope}.color.beige`,
    defaultMessage: 'Beige',
  },
  black: {
    id: `${scope}.color.black`,
    defaultMessage: 'Black',
  },
  blue: {
    id: `${scope}.color.blue`,
    defaultMessage: 'Blue',
  },
  brown: {
    id: `${scope}.color.brown`,
    defaultMessage: 'Brown',
  },
  gold: {
    id: `${scope}.color.gold`,
    defaultMessage: 'Gold',
  },
  green: {
    id: `${scope}.color.green`,
    defaultMessage: 'Green',
  },
  grey: {
    id: `${scope}.color.grey`,
    defaultMessage: 'Grey',
  },
  orange: {
    id: `${scope}.color.orange`,
    defaultMessage: 'Orange',
  },
  purple: {
    id: `${scope}.color.purple`,
    defaultMessage: 'Purple',
  },
  red: {
    id: `${scope}.color.red`,
    defaultMessage: 'Red',
  },
  silver: {
    id: `${scope}.color.silver`,
    defaultMessage: 'Silver',
  },
  white: {
    id: `${scope}.color.white`,
    defaultMessage: 'White',
  },
  yellow: {
    id: `${scope}.color.yellow`,
    defaultMessage: 'Yellow',
  },
  other: {
    id: `${scope}.color.other`,
    defaultMessage: 'Others',
  },
  othercolor: {
    id: `${scope}.color.othercolor`,
    defaultMessage: 'Autres',
  },
  otherColors: {
    id: `${scope}.color.othersColors`,
    defaultMessage: 'Other Colors',
  },
};

export const dynamicFilterMessages = {
  showResultsBtn: {
    id: `${scope}.showResultsBtn`,
    defaultMessage: 'Show {totalCount} results',
  },
  distance: {
    id: `${scope}.location.distance`,
    defaultMessage: `Distance: {distance, select,
      all {All}
      1 {{distance} mile}
      other {{distance} miles}
  }`,
    within: {
      id: `${scope}.location.within`,
      defaultMessage: 'Within',
    },
  },
  filtersWithin: {
    id: `${scope}.filtersWithin`,
    defaultMessage: `Within {distance, select,
      1 {{distance} mile}
      other {{distance} miles}
  }`,
  },
};

export const plpFiltersMessages = defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Filters',
  },
  panelLabel: {
    id: `${scope}.panelLabel`,
    defaultMessage: 'Filter panel',
  },
  closeBtn: {
    id: `${scope}.closeBtn`,
    defaultMessage: 'Close filter panel',
  },
  clearAllBtn: {
    id: `${scope}.clearAllBtn`,
    defaultMessage: 'Clear all',
  },
  clearBtn: {
    id: `${scope}.clearBtn`,
    defaultMessage: 'Clear',
  },
  viewMoreFilters: {
    id: `${scope}.viewMoreFilters`,
    defaultMessage: 'View more filters',
  },
  viewLessFilters: {
    id: `${scope}.viewLessFilters`,
    defaultMessage: 'View less filters',
  },
  viewAllFilters: {
    id: `${scope}.viewAllFilters`,
    defaultMessage: 'View all filters',
  },
  allLocations: {
    id: `${scope}.allLocations`,
    defaultMessage: 'All locations',
  },
  homepage: {
    id: `${scope}.homepage`,
    defaultMessage: 'Homepage',
  },
  allDealers: {
    id: `${scope}.allDealers`,
    defaultMessage: 'All dealers',
  },
  radiusTerritory: {
    id: `${scope}.radiusTerritory`,
    defaultMessage: 'Rayon: tout le territoire',
  },
  distanceLabel: {
    id: `${scope}.distanceLabel`,
    defaultMessage: 'Distance',
  },
  apply: { id: `${scope}.plp.apply`, defaultMessage: 'Apply' },
  promotionsFilterLabel: { id: `${scope}.promotionsFilterLabel`, defaultMessage: 'Promotions' },
  ...filterOverviewMessages,
  ...genericControlsMessages,
  ...accordionHeadingsMessages,
  ...priceMessages,
  ...fuelMessages,
  ...yearMessages,
  ...mileageMessages,
  ...evRangeMessages,
  ...vehicleSpecFuelTypeDefinition.messages,
  ...vehicleSpecGearBoxDefinition.messages,
  ...vehicleSpecBodyTypeDefinition.messages,
  ...enginePowerMessages,
  ...makeMessages,
  ...showOnlyMessages,
  ...newCarEu24Messages,
  ...includeSoldMessages,
  ...locationMessages,
  ...errorMessages,
  ...colorMessages,
  ...savedSearchMessages(scope),
  ...quickLinkMessages,
  ...promotionFilterMessages,
});
